<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :customMdList="codes.allOption"
              :customSmdList="codes.allOption"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="comboPrgType"
              :selected="frame0.selectData.COD_PRG_TYPE"
              :pageId="this.$options.name"
              codeId="COD_PRG_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TECHN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="comboPrgTechn"
              :selected="frame0.selectData.COD_PRG_TECHN"
              :pageId="this.$options.name"
              codeId="COD_PRG_TECHN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_DTSVC_USE_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <sui-code-select
              ref="comboPrgSrchCond"
              style="width: 250px !important;"
              :selected="frame0.selectData.COD_PRG_SEARCH_COND"
              :pageId="this.$options.name"
              codeId="COD_PRG_SEARCH_COND"
              :customOpitonList="codes.allOption"
              :initialSelectedIndex="0"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.codPrgSearchText"
              maxlength="100"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMS_00009'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="listGrid"
        :columns="gridColumns"
        :dataset="'dsPrgLst'"
        :enabletooltips="true"
        :showDisplayCountControl="false"
        :initialPagesize="5"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancelClick"
        >
          {{ this.$t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSelectClick"
        >
          {{ this.$t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMS_00009', // eslint-disable-line vue/name-property-casing
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageName: 'PGE_CMS_00009',
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_PRG_TYPE: {
            label: '',
            key: '',
          },
          COD_PRG_TECHN: {
            label: '',
            key: '',
          },
          COD_DTSVC_USE_YN: {
            label: '',
            key: '',
          },
          COD_PRG_SEARCH_COND: {
            label: '',
            key: '',
          },
          codPrgSearchText: '',
        },
      },
      localdata0: [],
      gridColumns: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_PRG_ID'),
        datafield: 'programId',
      }, {
        text: this.$t('MSG_TXT_PRG_NM'),
        datafield: 'programName',
      }, {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'programTypeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_TECHN'),
        datafield: 'programTechnName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'programUseYn',
        hidden: true,
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        hidden: true,
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        hidden: true,
      }],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadData();

    // 부모창에서 파라미터 받아서 조회하기
    if (this.pageInitialData.iptPrgName !== '') {
      this.frame0.codPrgSearchText = this.pageInitialData.iptPrgName;
      this.onSearchClick();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  datasets: [{
    id: 'dsPrgLst',
    type: 'local',
    data: 'localdata0',
    datafields: [
      {
        name: 'moduleName',
        type: 'string',
        map: 'moduleName',
      }, {
        name: 'subModuleName',
        type: 'string',
        map: 'subModuleName',
      }, {
        name: 'programId',
        type: 'string',
        map: 'programId',
      }, {
        name: 'programName',
        type: 'string',
        map: 'programName',
      }, {
        name: 'programTypeName',
        type: 'string',
        map: 'programTypeName',
      }, {
        name: 'programTechnName',
        type: 'string',
        map: 'programTechnName',
      }, {
        name: 'programUseYn',
        type: 'string',
        map: 'programUseYn',
      }, {
        name: 'finalModificationUserId',
        type: 'string',
        map: 'finalModificationUserId',
      }, {
        name: 'finalModificationDTM',
        type: 'string',
        map: 'finalModificationDTM',
      },
    ],
  }],
  methods: {
    loadData() {

    },
    onResetClick() {
      // this.$refs.smComboFrame0.reset();
      this.$refs.smComboFrame0.selectMd('ALL');
      this.$refs.comboPrgType.reset();
      this.$refs.comboPrgTechn.reset();
      this.$refs.comboUseYn.reset();
      this.$refs.comboPrgSrchCond.reset();
      this.frame0.codPrgSearchText = '';
    },
    onSearchClick() {
      const codeValue = this.frame0.selectData;
      const queryParams = {
        moduleCode: utils.trim(codeValue.COD_MDLE.key) || '',
        subModuleCode: utils.trim(codeValue.COD_SMDLE.key) || '',
        programTypeCode: utils.trim(codeValue.COD_PRG_TYPE.key) || '',
        programTechnCode: utils.trim(codeValue.COD_PRG_TECHN.key) || '',
        programUseYn: utils.trim(codeValue.COD_DTSVC_USE_YN.key) || '',
        searchCond: utils.trim(codeValue.COD_PRG_SEARCH_COND.key) || '',
        searchWord: utils.trim(this.frame0.codPrgSearchText) || '',
      };

      http.request(this.$options.name, 'DTS_CMS_00020', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        this.dsPrgLst.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    onSelectClick() {
      const selectedData = this.dsPrgLst.getSelectedRows();

      this.closePagePopup(selectedData);
    },
    onCancelClick() {
      this.closePagePopup('');
    },
  },
};
</script>
<style scoped>
</style>
